import React, { PropTypes, Component } from 'react';
import { MediaLibraryActions } from 'actions';
import { mixin, RefluxMixin } from 'Util';
import MediaLibraryDetail from 'components/Route/MediaLibrary/Detail';
import { MediaLibraryStore } from 'stores';
import Loader from 'components/Material/Loader';

export default class MediaLibraryDetailContainer extends mixin(
  RefluxMixin,
  Component
) {
  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  listenToStores() {
    this.listenToStore(MediaLibraryStore);
  }

  componentWillMount() {
    if (super.componentWillMount) {
      super.componentWillMount();
    }
    let { fileId } = this.props.routeParams;
    MediaLibraryActions.getFileInfo(fileId);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.routeParams.fileId !== nextProps.routeParams.fileId) {
      MediaLibraryActions.getFileInfo(nextProps.routeParams.fileId);
    }
  }

  componentWillUnmount() {
    if (super.componentWillUnmount) {
      super.componentWillUnmount();
    }
    MediaLibraryActions.clearSelected();
  }

  goBack = () => {
    this.props.router.goBack();
  };

  render() {
    const { selected } = this.state;
    if (!selected) {
      return <Loader />;
    }

    return (
      <MediaLibraryDetail
        key={selected.id}
        file={selected}
        onClose={this.goBack}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/MediaLibrary/MediaLibraryDetailContainer.js